<script>
  import { onMount } from "svelte";
  import { AWSAuth, Navigation, Sessions } from "@Services";

  import PlayerCore from '@Components/PlayerCore/index.svelte';

  const DEBUG = document.location.protocol === "http:" ? true : false;

  let isVisitor = true;
  let currentSession = null;
  let sessions = [];
  let classPlayer;

  onMount(async () => {
    if (DEBUG) console.log("Home, mounted");
    AWSAuth.isAnonymous().then(response => {
      if (DEBUG) console.log("isAnonymous: " + response);
      if (DEBUG) console.log("visitor: " + isVisitor);
      if (response !== isVisitor) {
        isVisitor = response;
        if (DEBUG) console.log("updated! " + isVisitor);
      }
    });
    sessions = Sessions.getSessions(false);
    const maxLength = sessions.length;
    const randomSession = Math.floor(Math.random() * maxLength);
    currentSession = sessions[randomSession];
  });
</script>

<style src="./style.scss">

</style>

<section class="featured-content">
  <header class="mbsc-row d-ns-logo">
    <picture class="mbsc-col mbsc-col-2 mbsc-offset-md-1 mbsc-offset-lg-2">
      <source media="(min-width:767px)" srcset="/images/logo-d-ns-studio.png" />
      <img src="/images/d-ns-logo.png" alt="D-NS Studio" />
    </picture>
    <div class="mbsc-col mbsc-offset-md-1 mbsc-col-md-4 mbsc-align-right">
      <nav class="popup-menu">
        <ul>
          <li>
            <button
              class="btn-popup"
              on:click={() => Navigation.goTo('account')}>
              Iniciar sesión
            </button>
          </li>
          <li>
            <button
              class="btn-popup"
              on:click={() => Navigation.goTo('signup')}>
              Regístrate
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </header>
  {#if currentSession}
    <PlayerCore
      videoClass='free-class-player'
      frontCamera={currentSession.streams._720.front}
      backCamera={currentSession.streams._720.back}
      poster={currentSession.poster}
      bind:videoPlayer={classPlayer}
      sessionId={currentSession.id}
    ></PlayerCore>
  {/if}
</section>
